import { Button, Grid, TextField, Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useState } from "react";

import { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


export const Contact = () => {

    const particlesInit = useCallback(async engine => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async container => {
        await console.log(container);
    }, []);
    const defaultValue = {
        name: "",
        email: "",
        work: "",
    };
    const [formDet, changeFormDet] = useState(defaultValue);
    const [subStatus, changeStatus] = useState(false);
    const handleChange = (e) => {
        console.log(e.target.name, e.target.value);
        changeFormDet({ ...formDet, [e.target.name]: e.target.value });
    };

    const encode = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&");
    }
    const handleSubmit = (e) => {
        changeStatus(true);
    }
    return (
        <Box className="no-overflow" bgcolor="#000000" sx={{ width: '100%', display: { xs: "block", md: "flex", lg: "flex" }, maxHeight: { xs: "none", md: "75vh", lg: "75vh" }, minHeight: { xs: "75vh", md: "25vh", lg: "25vh" }, justifyContent: "center", alignItems: { xs: "center", md: "center", lg: "center" }, p: { xs: "4rem", md: "5rem", lg: "5rem" }, textAlign: "center" }}>
            <Box className="no-overflow" sx={{ width: { xs: "100%", md: "30%", lg: "30%" }, alignItems: { xs: "center", md: "flex-start", lg: "flex-start" }, m: { xs: "auto" } }}>
                <Particles className="no-overflow"
                    id="tsparticles"
                    init={particlesInit}
                    loaded={particlesLoaded}
                    style={{ position: "absolute", left: "10px", top: "10px" }}
                    width="100vw"
                    height="75vh"
                    params={{
                        "autoPlay": true,
                        "defaultThemes": {},
                        "delay": 0,
                        "fullScreen": {
                            "enable": false,
                            "zIndex": -1
                        },
                        "detectRetina": true,
                        "duration": 0,
                        "fpsLimit": 120,
                        "interactivity": {
                            "detectsOn": "window",
                            "events": {
                                "onClick": {
                                    "enable": false,
                                    "mode": []
                                },
                                "onDiv": {
                                    "selectors": [],
                                    "enable": false,
                                    "mode": [],
                                    "type": "circle"
                                },
                                "onHover": {
                                    "enable": false,
                                    "mode": [],
                                    "parallax": {
                                        "enable": false,
                                        "force": 2,
                                        "smooth": 10
                                    }
                                },
                                "resize": {
                                    "delay": 0.5,
                                    "enable": true
                                }
                            },
                            "modes": {
                                "attract": {
                                    "distance": 200,
                                    "duration": 0.4,
                                    "easing": "ease-out-quad",
                                    "factor": 1,
                                    "maxSpeed": 50,
                                    "speed": 1
                                },
                                "bounce": {
                                    "distance": 200
                                },
                                "bubble": {
                                    "distance": 200,
                                    "duration": 0.4,
                                    "mix": false,
                                    "divs": {
                                        "distance": 200,
                                        "duration": 0.4,
                                        "mix": false,
                                        "selectors": []
                                    }
                                },
                                "connect": {
                                    "distance": 80,
                                    "links": {
                                        "opacity": 0.5
                                    },
                                    "radius": 60
                                },
                                "grab": {
                                    "distance": 100,
                                    "links": {
                                        "blink": false,
                                        "consent": false,
                                        "opacity": 1
                                    }
                                },
                                "push": {
                                    "default": true,
                                    "groups": [],
                                    "quantity": 4
                                },
                                "remove": {
                                    "quantity": 2
                                },
                                "repulse": {
                                    "distance": 200,
                                    "duration": 0.4,
                                    "factor": 100,
                                    "speed": 1,
                                    "maxSpeed": 50,
                                    "easing": "ease-out-quad",
                                    "divs": {
                                        "distance": 200,
                                        "duration": 0.4,
                                        "factor": 100,
                                        "speed": 1,
                                        "maxSpeed": 50,
                                        "easing": "ease-out-quad",
                                        "selectors": []
                                    }
                                },
                                "slow": {
                                    "factor": 3,
                                    "radius": 200
                                },
                                "trail": {
                                    "delay": 1,
                                    "pauseOnStop": false,
                                    "quantity": 1
                                },
                                "light": {
                                    "area": {
                                        "gradient": {
                                            "start": {
                                                "value": "#ffffff"
                                            },
                                            "stop": {
                                                "value": "#000000"
                                            }
                                        },
                                        "radius": 1000
                                    },
                                    "shadow": {
                                        "color": {
                                            "value": "#000000"
                                        },
                                        "length": 2000
                                    }
                                }
                            }
                        },
                        "manualParticles": [],
                        "particles": {
                            "bounce": {
                                "horizontal": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0.1
                                    },
                                    "value": 1
                                },
                                "vertical": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0.1
                                    },
                                    "value": 1
                                }
                            },
                            "collisions": {
                                "absorb": {
                                    "speed": 2
                                },
                                "bounce": {
                                    "horizontal": {
                                        "random": {
                                            "enable": false,
                                            "minimumValue": 0.1
                                        },
                                        "value": 1
                                    },
                                    "vertical": {
                                        "random": {
                                            "enable": false,
                                            "minimumValue": 0.1
                                        },
                                        "value": 1
                                    }
                                },
                                "enable": false,
                                "mode": "bounce",
                                "overlap": {
                                    "enable": true,
                                    "retries": 0
                                }
                            },
                            "color": {
                                "value": "#fff",
                                "animation": {
                                    "h": {
                                        "count": 0,
                                        "enable": false,
                                        "offset": 0,
                                        "speed": 1,
                                        "decay": 0,
                                        "sync": true
                                    },
                                    "s": {
                                        "count": 0,
                                        "enable": false,
                                        "offset": 0,
                                        "speed": 1,
                                        "decay": 0,
                                        "sync": true
                                    },
                                    "l": {
                                        "count": 0,
                                        "enable": false,
                                        "offset": 0,
                                        "speed": 1,
                                        "decay": 0,
                                        "sync": true
                                    }
                                }
                            },
                            "groups": {},
                            "move": {
                                "angle": {
                                    "offset": 0,
                                    "value": 90
                                },
                                "attract": {
                                    "distance": 200,
                                    "enable": false,
                                    "rotate": {
                                        "x": 3000,
                                        "y": 3000
                                    }
                                },
                                "center": {
                                    "x": 50,
                                    "y": 50,
                                    "mode": "percent",
                                    "radius": 0
                                },
                                "decay": 0,
                                "distance": {},
                                "direction": "top",
                                "drift": 0,
                                "enable": true,
                                "gravity": {
                                    "acceleration": 9.81,
                                    "enable": false,
                                    "inverse": false,
                                    "maxSpeed": 50
                                },
                                "path": {
                                    "clamp": false,
                                    "delay": {
                                        "random": {
                                            "enable": false,
                                            "minimumValue": 0
                                        },
                                        "value": 0
                                    },
                                    "enable": false,
                                    "options": {
                                        "sides": 6,
                                        "turnSteps": 30,
                                        "angle": 30
                                    }
                                },
                                "outModes": {
                                    "default": "out",
                                    "bottom": "out",
                                    "left": "out",
                                    "right": "out",
                                    "top": "out"
                                },
                                "random": false,
                                "size": false,
                                "speed": 4,
                                "spin": {
                                    "acceleration": 0,
                                    "enable": false
                                },
                                "straight": true,
                                "trail": {
                                    "enable": false,
                                    "length": 10,
                                    "fill": {
                                        "color": {
                                            "value": "#000"
                                        }
                                    }
                                },
                                "vibrate": false,
                                "warp": false
                            },
                            "number": {
                                "density": {
                                    "enable": true,
                                    "width": 1920,
                                    "height": 1080
                                },
                                "limit": 0,
                                "value": 100
                            },
                            "opacity": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0.1
                                },
                                "value": {
                                    "min": 0.1,
                                    "max": 1
                                },
                                "animation": {
                                    "count": 0,
                                    "enable": true,
                                    "speed": 0.25,
                                    "decay": 0,
                                    "sync": false,
                                    "destroy": "none",
                                    "startValue": "random"
                                }
                            },
                            "reduceDuplicates": false,
                            "shadow": {
                                "blur": 0,
                                "color": {
                                    "value": "#000"
                                },
                                "enable": false,
                                "offset": {
                                    "x": 0,
                                    "y": 0
                                }
                            },
                            "shape": {
                                "options": {},
                                "type": "circle"
                            },
                            "size": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 1
                                },
                                "value": 1,
                                "animation": {
                                    "count": 0,
                                    "enable": false,
                                    "speed": 5,
                                    "decay": 0,
                                    "sync": false,
                                    "destroy": "none",
                                    "startValue": "random"
                                }
                            },
                            "stroke": {
                                "width": 0
                            },
                            "zIndex": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0
                                },
                                "value": 0,
                                "opacityRate": 1,
                                "sizeRate": 1,
                                "velocityRate": 1
                            },
                            "life": {
                                "count": 0,
                                "delay": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0
                                    },
                                    "value": 0,
                                    "sync": false
                                },
                                "duration": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0.0001
                                    },
                                    "value": 0,
                                    "sync": false
                                }
                            },
                            "rotate": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0
                                },
                                "value": 0,
                                "animation": {
                                    "enable": false,
                                    "speed": 0,
                                    "decay": 0,
                                    "sync": false
                                },
                                "direction": "clockwise",
                                "path": false
                            },
                            "destroy": {
                                "bounds": {},
                                "mode": "none",
                                "split": {
                                    "count": 1,
                                    "factor": {
                                        "random": {
                                            "enable": false,
                                            "minimumValue": 0
                                        },
                                        "value": 3
                                    },
                                    "rate": {
                                        "random": {
                                            "enable": false,
                                            "minimumValue": 0
                                        },
                                        "value": {
                                            "min": 4,
                                            "max": 9
                                        }
                                    },
                                    "sizeOffset": true,
                                    "particles": {}
                                }
                            },
                            "roll": {
                                "darken": {
                                    "enable": false,
                                    "value": 0
                                },
                                "enable": false,
                                "enlighten": {
                                    "enable": false,
                                    "value": 0
                                },
                                "mode": "vertical",
                                "speed": 25
                            },
                            "tilt": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0
                                },
                                "value": 0,
                                "animation": {
                                    "enable": false,
                                    "speed": 0,
                                    "decay": 0,
                                    "sync": false
                                },
                                "direction": "clockwise",
                                "enable": false
                            },
                            "twinkle": {
                                "lines": {
                                    "enable": false,
                                    "frequency": 0.05,
                                    "opacity": 1
                                },
                                "particles": {
                                    "enable": false,
                                    "frequency": 0.05,
                                    "opacity": 1
                                }
                            },
                            "wobble": {
                                "distance": 5,
                                "enable": false,
                                "speed": {
                                    "angle": 50,
                                    "move": 10
                                }
                            },
                            "orbit": {
                                "animation": {
                                    "count": 0,
                                    "enable": false,
                                    "speed": 1,
                                    "decay": 0,
                                    "sync": false
                                },
                                "enable": false,
                                "opacity": 1,
                                "rotation": {
                                    "random": {
                                        "enable": false,
                                        "minimumValue": 0
                                    },
                                    "value": 45
                                },
                                "width": 1
                            },
                            "links": {
                                "blink": false,
                                "color": {
                                    "value": "#fff"
                                },
                                "consent": false,
                                "distance": 100,
                                "enable": false,
                                "frequency": 1,
                                "opacity": 1,
                                "shadow": {
                                    "blur": 5,
                                    "color": {
                                        "value": "#000"
                                    },
                                    "enable": false
                                },
                                "triangles": {
                                    "enable": false,
                                    "frequency": 1
                                },
                                "width": 1,
                                "warp": false
                            },
                            "repulse": {
                                "random": {
                                    "enable": false,
                                    "minimumValue": 0
                                },
                                "value": 0,
                                "enabled": false,
                                "distance": 1,
                                "duration": 1,
                                "factor": 1,
                                "speed": 1
                            }
                        },
                        "pauseOnBlur": true,
                        "pauseOnOutsideViewport": true,
                        "responsive": [],
                        "smooth": false,
                        "style": {},
                        "themes": [],
                        "zLayers": 100,
                        "emitters": []
                    }} />
                <Typography sx={{
                    display: { xs: 'flex', md: "flex", lg: 'flex' },
                    fontFamily: 'Title',
                    fontSize: { xs: "1rem", md: "2rem", lg: "2rem" },
                    // fontWeight: 700,
                    color: 'white',
                    letterSpacing: '.2rem',
                    textDecoration: 'none',
                    textAlign: { xs: "left", md: "left", lg: "left" },
                    textTransform: "capitalize"
                }} >Let's Solve your Problem
                </Typography>
                <Typography sx={{
                    display: { xs: 'flex', md: "flex", lg: 'flex' },
                    fontFamily: 'Title',
                    fontSize: { xs: "1rem", md: "2rem", lg: "2rem" },
                    letterSpacing: '.2rem',
                    // fontWeight: 700,
                    color: '#ECBC55',
                    textDecoration: 'none',
                    textAlign: { xs: "left", md: "left", lg: "left" },
                    mb: "1.5rem",
                    textTransform: "capitalize"
                }} > together!</Typography>
                <Typography sx={{
                    display: { xs: 'flex', md: "flex", lg: 'flex' },
                    fontFamily: 'Title',
                    fontSize: { xs: "0.75rem", md: "1.25rem", lg: "1.25rem" },
                    // fontWeight: 700,
                    color: 'white',
                    textDecoration: 'none',
                    textAlign: { xs: "left", md: "left", lg: "left" },
                    mb: "1.5rem",
                    textTransform: "capitalize"
                }} >Fill the Form or just use my contact details given below! </Typography>
                <Typography sx={{
                    display: { xs: 'flex', md: "flex", lg: 'flex' },
                    fontFamily: 'Title',
                    fontSize: { xs: "0.75rem", md: "1.25rem", lg: "1.25rem" },
                    // fontWeight: 700,
                    color: 'white',
                    textDecoration: 'none',
                    letterSpacing: '.1rem',
                    textAlign: { xs: "left", md: "left", lg: "left" },
                }} >Email :</Typography>
                <Typography sx={{
                    display: { xs: 'flex', md: "flex", lg: 'flex' },
                    fontFamily: 'Title',
                    fontSize: { xs: "0.75rem", md: "1.25rem", lg: "1.25rem" },
                    // fontWeight: 700,
                    color: '#ECBC55',
                    textDecoration: 'none',
                    letterSpacing: '.1rem',
                    textAlign: { xs: "left", md: "left", lg: "left" },
                    hyphens: "auto",
                    wordWrap: "break-word",
                    width: "100%",
                    mb: { xs: "1rem", md: "1.5rem", lg: "1.5rem" },
                }} >bhanushalimann@gmail.com</Typography>

            </Box>
            <Grid className="no-overflow" container spacing={2} direction="column" justifyContent="center" alignItems="center" maxHeight="75vh" minHeight="25vh" color="white" sx={{ p: { xs: "1rem", md: "5rem", lg: "5rem" }, maxWidth: { xs: "100%", md: "50%", lg: "50%" }, display: { xs: "block", md: "flex", lg: "flex" } }} >
                <form method="POST" className="no-overflow contactForm" netlify name="contactForm" onSubmit={handleSubmit}>
                    <input
                        type='hidden'
                        name='form-name'
                        value='contactForm' />
                    <Grid item sx={{ m: "auto", mt: "1rem", width: "100%" }}>
                        <TextField sx={{
                            "& .MuiOutlinedInput-root": {
                                "& > fieldset": { borderColor: "#ECBC55" },
                            },
                            "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": { borderColor: "white" },
                            },
                            "& .MuiOutlinedInput-root:active": {
                                "& > fieldset": { borderColor: "white" },
                            },
                        }} id="outlined-basic" label="Enter your Name" placeholder="Enter Your Name" variant="outlined" fullWidth name="name" required
                            InputLabelProps={{
                                style: { color: "white" },
                            }}
                            InputProps={{
                                style: { color: "white", borderColor: "white" },
                            }}
                            onChange={handleChange} />
                    </Grid>
                    <Grid item sx={{ m: "auto", mt: "1rem" }}>
                        <TextField type="email" sx={{
                            "& .MuiOutlinedInput-root": {
                                "& > fieldset": { borderColor: "#ECBC55" },
                            },
                            "& .MuiOutlinedInput-root:hover": {
                                "& > fieldset": { borderColor: "white" },
                            },
                            "& .MuiOutlinedInput-root:focus": {
                                "& > fieldset": { borderColor: "white" },
                            },
                        }} id="outlined-basic" label="Enter your Email" placeholder="Enter Your Email" variant="outlined" fullWidth required name="email"
                            InputLabelProps={{
                                style: { color: "white" },
                            }}
                            InputProps={{
                                style: { color: "white", borderColor: "white" },
                            }}
                            onChange={handleChange} />
                    </Grid>
                    <Grid item sx={{ m: "auto", mt: "1rem" }}>
                        <TextField multiline={true} rows={5}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& > fieldset": { borderColor: "#ECBC55" },
                                },
                                "& .MuiOutlinedInput-root:hover": {
                                    "& > fieldset": { borderColor: "white" },
                                },
                                "& .MuiOutlinedInput-root:focus": {
                                    "& > fieldset": { borderColor: "white" },
                                },
                            }} id="outlined-basic" label="What can I help you with?" placeholder="What can I help you with?" variant="outlined" fullWidth required name="work"
                            InputLabelProps={{
                                style: { color: "white" },
                            }}
                            InputProps={{
                                style: { color: "white", borderColor: "white" },
                            }}
                            onChange={handleChange} />
                    </Grid>
                    <Grid item sx={{ m: "auto", mt: "1rem", width: "100%" }}>
                        <Button variant="outlined" type="submit" sx={{
                            fontFamily: "Title", letterSpacing: '.2rem', fontSize: { xs: "0.5rem", md: "medium", lg: "medium" },
                            textAlign: { xs: "center", md: "left", lg: "left" }, alignSelf: "flex-start", color: "white", padding: "0.5rem", width: { xs: "10rem", md: "10rem", lg: "10rem" }, borderColor: subStatus ? "green" : "#ECBC55",
                            ":hover": { backgroundColor: "#FDDF9E", color: "#1D1F2A", }
                        }}>Submit Form</Button>
                    </Grid>
                </form>
            </Grid>
        </Box>
    )
}